import {makeStyles} from '@material-ui/core/styles'
// import {modalContent} from '@assets/jss/theme.global'

export default makeStyles((theme) => ({
  drawPaper: {
    width: "40%",
    maxWidth: "500px",
    padding: "32px 32px 50px",
    color: "#131313",
  },
  drawTitle: {
    fontSize: "24px",
    lineHeight: "28px",
    color: "#131313",
    marginBottom: "44px",
    textAlign: "center",
    position: "relative",
  },
  drawAmout: {
    fontSize: "48px",
    lineHeight: "56px",
    color: "#131313",
    marginBottom: "14px",
    textAlign: "center",
  },
  drawId: {
    fontSize: "20px",
    lineHeight: "23px",
    color: "#131313",
    marginBottom: "42px",
    textAlign: "center",
  },
  drawLabel: {
    fontSize: "14px",
    lineHeight: "16px",
    marginTop: "24px",
    marginBottom: "14px",
  },
  drawTime: {
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "19px",
    marginBottom: "20px",
  },
  drawTransferContainer: {
    marginBottom: "25px",
    marginTop: "24px",
  },
  drawTransfer: {
    fontWeight: 500,
    fontSize: "20px",
    lineHeight: "24px",
  },
  drawTablePaper: {
    boxShadow: "none",
    marginBottom: "7px",
  },
  drawTableCell: {
    paddingLeft: 0,
    paddingRight: 0,
    color: "#4C4C4C",
  },
  statusBtn: {
    width: "calc(100% - 10px)",
    textTransform: "none",
    lineHeight: "19px",
    fontSize: "16px",
    cursor: "auto",
    boxShadow: "none",
    cursor: "pointer"
  },
  statusBtnReject: {
    borderColor: "#E71919",
    color: "#E71919",
    maxWidth: "271px",
    "&:hover": {
      borderColor: "#E71919",
      color: "#E71919",
      backgroundColor: "#e7191908",
    },
  },
  statusBtnAccept: {
    borderColor: "#41B60B !important",
    color: "#41B60B !important",
    maxWidth: "271px",
  },
  drawInfo: {
    color: "#4C4C4C",
    fontSize: "14px",
    lineHeight: "16px",
    marginTop: "8px",
    marginBottom: "-2px",
  },
  infoContainer: {
    marginBottom: "10px",
  },
  drawIconClose: {
    width: "40px",
    height: "40px",
    padding: "8px",
    position: "absolute",
    top: "50%",
    right: "0",
    transform: "translate(0, -50%)",

    "& img": {
      width: "100%",
    },
  },
  wrapfiled:{
    marginTop: "20px"
  },
  btnRegister:{
    display: "flex",
    justifyContent: "center",
    padding: "20px",
    marginTop: "20px"
  },
  textError:{
    color: "red",
    fontSize: "14px",
    paddingTop: "10px"
  }
}));